export default function Privacy() {
  const updated = "13 March 2026";
  return (
    <div style={{ background: "#F7F4EE", color: "#1F2E3B", fontFamily: "'DM Sans', sans-serif", minHeight: "100vh" }}>

      {/* Skip link */}
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:rounded-lg focus:text-sm focus:font-medium"
        style={{ background: "#6FAFB5", color: "#fff", textDecoration: "none" }}>
        Skip to main content
      </a>

      {/* Nav */}
      <nav aria-label="Site navigation" style={{ background: "rgba(247,244,238,.95)", borderBottom: "1px solid #e4ddd2", position: "sticky", top: 0, zIndex: 50, backdropFilter: "blur(14px)" }}>
        <div style={{ maxWidth: 1120, margin: "0 auto", padding: "0.85rem 1.75rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <a href="/" aria-label="BizDr — go to homepage" style={{ display: "flex", alignItems: "center", gap: "0.6rem", textDecoration: "none" }}>
            <svg width="28" height="16" viewBox="0 0 28 16" fill="none" aria-hidden="true" focusable="false">
              <path d="M1 8 L5.5 8 L8 1.5 L10.5 14.5 L13.5 8 L27 8"
                stroke="#6FAFB5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.4rem", letterSpacing: "-0.01em", color: "#1F2E3B", lineHeight: 1 }}>
              Biz<em style={{ fontStyle: "italic", color: "#3a7178" }}>Dr</em>
            </span>
          </a>
          <a href="/#contact" style={{ background: "#1F2E3B", color: "#fff", borderRadius: 999, padding: "0.6rem 1.4rem", fontSize: "0.88rem", fontWeight: 500, textDecoration: "none" }}>
            Book a BizDr Check
          </a>
        </div>
      </nav>

      <main id="main-content">
        <div style={{ maxWidth: 760, margin: "0 auto", padding: "4rem 1.75rem 6rem" }}>

          <div style={{ marginBottom: "0.75rem", fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.2em", color: "#4e8f95", fontWeight: 500 }}>Legal</div>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem,4vw,3rem)", fontWeight: 700, lineHeight: 1.15, marginBottom: "0.75rem" }}>
            Privacy Policy
          </h1>
          <p style={{ color: "#536270", marginBottom: "3rem", fontSize: "0.9rem" }}>Last updated: {updated}</p>

          <div style={{ display: "flex", flexDirection: "column", gap: "2.5rem" }}>

            <Section title="1. Who we are">
              <p>BizDr ("we", "us", "our") is a small business website design and consulting service operating across regional Australia. We are committed to protecting your personal information in accordance with the <strong>Privacy Act 1988 (Cth)</strong> and the <strong>Australian Privacy Principles (APPs)</strong>.</p>
              <p>To contact us about privacy matters: <a href="mailto:bizdrinfo@gmail.com" style={{ color: "#4e8f95" }}>bizdrinfo@gmail.com</a></p>
            </Section>

            <Section title="2. What information we collect">
              <p>We collect personal information only when you voluntarily contact us through our website enquiry form. The information collected may include:</p>
              <ul>
                <li>Your name and business name</li>
                <li>Email address</li>
                <li>Phone number (optional)</li>
                <li>The nature of your enquiry or service interest</li>
                <li>Details about your business that you choose to share</li>
              </ul>
              <p>We do not collect sensitive information (such as health, financial, or government identifier data) through our website.</p>
              <p>We do not use cookies, tracking pixels, or analytics services on this website.</p>
            </Section>

            <Section title="3. Why we collect your information">
              <p>We collect your information solely to:</p>
              <ul>
                <li>Respond to your enquiry about our services</li>
                <li>Provide you with a quote, demo, or information you have requested</li>
                <li>Follow up on a previous conversation about a project</li>
              </ul>
              <p>We will not use your information for unsolicited direct marketing. If we believe our services may benefit you and wish to follow up, we will only do so in direct response to an enquiry you have made. You may opt out of any follow-up at any time by contacting us at <a href="mailto:bizdrinfo@gmail.com" style={{ color: "#4e8f95" }}>bizdrinfo@gmail.com</a>.</p>
            </Section>

            <Section title="4. How we store and protect your information">
              <p>Enquiries submitted through our contact form are delivered by email via <strong>Resend</strong> (a transactional email service). Resend processes your message in order to deliver it to us — they act as a data processor on our behalf. You can review Resend's privacy policy at <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: "#4e8f95" }}>resend.com/legal/privacy-policy</a>.</p>
              <p>Once received, your information is stored in our email inbox (Google Gmail). Google's privacy policy applies to that storage: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#4e8f95" }}>policies.google.com/privacy</a>.</p>
              <p>We take reasonable steps to protect your personal information from misuse, interference, and loss, and from unauthorised access, modification, or disclosure.</p>
            </Section>

            <Section title="5. Disclosure to third parties">
              <p>We do not sell, trade, rent, or share your personal information with any third parties for marketing or commercial purposes.</p>
              <p>We will only disclose your personal information to a third party if:</p>
              <ul>
                <li>You have given us consent to do so</li>
                <li>We are required to do so by law or a court order</li>
                <li>It is necessary to protect the safety of any person</li>
              </ul>
              <p>The only third-party service provider who processes your data is Resend (email delivery), as described in Section 4.</p>
            </Section>

            <Section title="6. Accessing, correcting or deleting your information">
              <p>Under the Australian Privacy Principles, you have the right to:</p>
              <ul>
                <li>Request access to the personal information we hold about you</li>
                <li>Request that we correct any inaccurate or out-of-date information</li>
                <li>Request that we delete your information (subject to any legal obligations to retain records)</li>
              </ul>
              <p>To make any of these requests, please email us at <a href="mailto:bizdrinfo@gmail.com" style={{ color: "#4e8f95" }}>bizdrinfo@gmail.com</a>. We will respond within 30 days.</p>
            </Section>

            <Section title="7. Anonymity and pseudonymity">
              <p>Where practicable, you may contact us without identifying yourself (e.g. general enquiries). However, if you request a specific service or quote, we will need your contact details in order to respond.</p>
            </Section>

            <Section title="8. Links to other websites">
              <p>Our website contains links to external websites including <strong>dogplaces.app</strong> and <strong>goable.app</strong>. These sites have their own privacy policies and we are not responsible for the content or privacy practices of those sites. We encourage you to review their policies before providing personal information.</p>
            </Section>

            <Section title="9. Changes to this policy">
              <p>We may update this privacy policy from time to time to reflect changes in our practices or legal obligations. The most current version will always be available at this URL. We encourage you to review it periodically.</p>
            </Section>

            <Section title="10. Complaints">
              <p>If you believe we have breached the Australian Privacy Principles, you may first contact us directly at <a href="mailto:bizdrinfo@gmail.com" style={{ color: "#4e8f95" }}>bizdrinfo@gmail.com</a> so we can attempt to resolve the matter.</p>
              <p>If you are not satisfied with our response, you have the right to lodge a complaint with the <strong>Office of the Australian Information Commissioner (OAIC)</strong>:</p>
              <ul>
                <li>Website: <a href="https://www.oaic.gov.au" target="_blank" rel="noopener noreferrer" style={{ color: "#4e8f95" }}>www.oaic.gov.au</a></li>
                <li>Phone: 1300 363 992</li>
                <li>Post: GPO Box 5288, Sydney NSW 2001</li>
              </ul>
            </Section>

            <Section title="11. Accessibility commitment">
              <p>BizDr is committed to ensuring this website is accessible to all people, including those with disability. We aim to meet <strong>WCAG 2.1 Level AA</strong> standards in accordance with Australia's <strong>Disability Discrimination Act 1992 (Cth)</strong>.</p>
              <p>If you experience any accessibility barriers on our website, please contact us at <a href="mailto:bizdrinfo@gmail.com" style={{ color: "#4e8f95" }}>bizdrinfo@gmail.com</a> and we will do our best to assist you and address any issues promptly.</p>
            </Section>

          </div>

          <div className="mt-16 pt-8" style={{ borderTop: "1px solid #e4ddd2" }}>
            <a href="/" style={{ color: "#4e8f95", textDecoration: "none", fontSize: "0.88rem", fontWeight: 500 }}>← Back to BizDr</a>
          </div>
        </div>
      </main>

      <footer style={{ background: "#1F2E3B", padding: "2rem 1.75rem" }}>
        <div style={{ maxWidth: 1120, margin: "0 auto", display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "1rem" }}>
          <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <svg width="22" height="13" viewBox="0 0 28 16" fill="none" aria-hidden="true" focusable="false">
              <path d="M1 8 L5.5 8 L8 1.5 L10.5 14.5 L13.5 8 L27 8"
                stroke="#6FAFB5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.1rem", letterSpacing: "-0.01em", color: "#fff", lineHeight: 1 }}>
              Biz<em style={{ fontStyle: "italic", color: "#6FAFB5" }}>Dr</em>
            </span>
          </span>
          <div style={{ display: "flex", gap: "1.5rem", flexWrap: "wrap" }}>
            <a href="/" style={{ color: "rgba(255,255,255,.4)", textDecoration: "none", fontSize: "0.82rem" }}>Home</a>
            <a href="/privacy" style={{ color: "rgba(255,255,255,.7)", textDecoration: "none", fontSize: "0.82rem" }}>Privacy Policy</a>
            <a href="/#contact" style={{ color: "rgba(255,255,255,.4)", textDecoration: "none", fontSize: "0.82rem" }}>Contact</a>
          </div>
          <span style={{ color: "rgba(255,255,255,.3)", fontSize: "0.78rem" }}>© {new Date().getFullYear()} BizDr. All rights reserved. · ABN 69 491 275 460</span>
        </div>
      </footer>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section aria-labelledby={title.replace(/\s+/g, "-").replace(/[^a-z0-9-]/gi, "").toLowerCase()}>
      <h2
        id={title.replace(/\s+/g, "-").replace(/[^a-z0-9-]/gi, "").toLowerCase()}
        style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.25rem", fontWeight: 500, color: "#1F2E3B", marginBottom: "0.85rem" }}>
        {title}
      </h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem", color: "#536270", lineHeight: 1.8, fontSize: "0.95rem" }}>
        {children}
      </div>
    </section>
  );
}
